import {
    THREATMETRIX_ADVANCED_SERVICE_OFFERING_ID,
    THREATMETRIX_SESSION_QUERY_HIGH_ACCURACY_SERVICE_OFFERING_ID,
    THREATMETRIX_SESSION_QUERY_LOW_ACCURACY_SERVICE_OFFERING_ID,
    TMX_EVENT_TYPE_PROPERTY_TYPE_ID
} from "@constants/verification-service-details-constants";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { FormattedAppliedProfile } from "@idw-types/data/applied-profile/applied-profile";
import { FormattedRpServiceConfigurationProperty, FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { getRpServicePropertyValueOrAppliedProfilePropertyValue } from "@utils/applied-profile-util";

export const getTmxEventType = (properties: Array<FormattedRpServiceConfigurationProperty>, appliedProfiles: Array<FormattedAppliedProfile>): string => {
    const tmxEventTypePropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, TMX_EVENT_TYPE_PROPERTY_TYPE_ID);
    return tmxEventTypePropertyValue;
};

export const hasTmxServiceOffering = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>) => {
    return serviceOfferings
        .some(so => so.addedToService && so.status === EntityStatusTypes.ACTIVE && [
            THREATMETRIX_SESSION_QUERY_LOW_ACCURACY_SERVICE_OFFERING_ID,
            THREATMETRIX_SESSION_QUERY_HIGH_ACCURACY_SERVICE_OFFERING_ID,
            THREATMETRIX_ADVANCED_SERVICE_OFFERING_ID
        ].includes(so.serviceOfferingID));
};